import { queryOptions } from '@tanstack/react-query';

import { getDomainQuery, getDomainsQuery } from './shared';

export const getDomainQueryOptions = (id: string) => queryOptions(getDomainQuery(id));
export const getDomainsQueryOptions = () => queryOptions(getDomainsQuery());
